import { Menu } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';

import styled from 'styled-components';

export const DropDownSpan = styled.span`
  height: 2em;
  align-self: flex-start;
  cursor: pointer;
  font-size: 25px;

  i {
    color: #2b9bff;
  }
`;

export const FeedbackMutedIcon = styled.img`
  height: 1em;
  margin-left: 5px;
`;

export const StyledMenuItem = styled(Menu.Item)`
  p {
    padding: 8px 12px;
    line-height: 14px;
    color: #201e1e;
  }
  &:hover {
    background: #f0f2f5 !important;
  }
  &.create-booking-link {
    color: #1890ff;
  }
  &[data-divider='true'] {
    border-top: 1px solid #e9e9e9;
    padding-top: 16px;
  }
`;

export const StyledSubMenu = styled(SubMenu)`
  &.create-booking-link div {
    color: #1890ff;
  }
`;
